var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arterra-quotes"},[_c('blockquote',{staticClass:"blockquote text-center quote",class:{quotehide: this.doHide}},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.quote.text))]),_vm._v(" "),(_vm.quote.author)?_c('footer',{staticClass:"blockquote-footer"},[_vm._v(_vm._s(_vm.quote.author))]):_vm._e()])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-983ed19e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Quotes.vue
// module id = 3PG0
// module chunks = 0